import { Component } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { firebaseAuthTranslation } from '../../../util/FirebaseErrorTranslation';
import {
  hasMinLength,
  hasLowercase,
  hasUppercase,
  PASSWORD_VALIDATE_REGEX,
} from '../../../util/PasswordUtil';
import { CommonModule } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-register',
  imports: [
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    CommonModule,
  ],
  templateUrl: './register.page.html',
  styleUrl: './register.page.scss',
})
export class RegisterPage {
  isRegisterInitiated = false;
  showPassword = false;

  hasMinLength = hasMinLength;
  hasLowercase = hasLowercase;
  hasUppercase = hasUppercase;

  registerForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [
      Validators.required,
      Validators.pattern(PASSWORD_VALIDATE_REGEX),
    ])
  });

  ngOnInit() {
    const registrationCode =
      this._route.snapshot.queryParams['registrationCode'];
    if (registrationCode) {
      localStorage.setItem('registrationCode', registrationCode);
    }
  }

  constructor(
    private _auth: AuthService,
    private _toast: ToastService,
    private _route: ActivatedRoute,
    private _router: Router,
  ) { }

  async performRegistration() {
    if (this.registerForm.invalid) {
      Object.keys(this.registerForm.controls).forEach((key) => {
        const control: any = this.registerForm.get(key);
        control.markAsTouched();
        control.markAsDirty();
      });
      this._toast.add({
        severity: 'contrast',
        summary: 'Bitte alle Felder ausfüllen',
      });
      return;
    }
    this.isRegisterInitiated = true;
    this.registerForm.disable();

    try {
      await firstValueFrom(
        this._auth.register(
          this.registerForm.value.email!,
          this.registerForm.value.password!,
        ),
      );
      this.isRegisterInitiated = false;
      this._toast.add({
        severity: 'success',
        summary: 'Registrierung erfolgreich',
        detail:
          'Du hast dich erfolgreich registriert, in kürze erhälst du eine Bestätigungsmail.',
      });

      setTimeout(() => {
        this._router.navigate(['/auth/onboarding']);
      }, 3000);
    } catch (error: any) {
      this.isRegisterInitiated = false;
      this.registerForm.enable();

      const errorTranslation = firebaseAuthTranslation[error.code];

      if (errorTranslation?.toDev) console.error(errorTranslation.toDev);
      this._toast.add({
        severity: 'contrast',
        summary: 'Registrierung fehlgeschlagen',
        detail: errorTranslation?.toClient ?? 'Interner Serverfehler',
      });
    }
  }
}